import { translate } from "app/filters/i18nFilter";
import { columnKeys } from "app/pages/sales-intelligence/utils/i18n/columns";

import type { SimilarwebFieldsConfig } from "app/pages/sales-intelligence/common-components/export-table/types";

const OPPORTUNITY_LIST_NAME_FIELD = "opportunity_list_name";

export const getOpportunityListFieldsConfig = (): SimilarwebFieldsConfig => {
    const config = {
        [OPPORTUNITY_LIST_NAME_FIELD]: {
            name: translate(columnKeys.title("opportunity_list_name")),
            example: "My Account List",
            field: "opportunity_list_name",
        },
    };

    return Object.seal(config);
};

export const getOpportunityListFieldsKeys = () => Object.keys(getOpportunityListFieldsConfig());
